module.exports = __webpack_public_path__ + "img/help-wc.2c19ffe0.png";